// src/utils/webSources.ts

/**
 * Host of Google's grounding redirect links. Gemini's web sources point here
 * rather than at the site, so the host says nothing about where a link leads.
 */
export const GROUNDING_REDIRECT_HOST = "vertexaisearch.cloud.google.com";

const hostOf = (url: string): string => {
  try {
    return new URL(url).hostname;
  } catch {
    return "";
  }
};

/**
 * The site a web source belongs to. For a Google grounding redirect that is the
 * label Google gives the source, which is the site's domain.
 */
export const sourceSiteDomain = (url: string | undefined, label: string): string => {
  const host = url ? hostOf(url) : "";

  return host === GROUNDING_REDIRECT_HOST ? label : host;
};

/**
 * Google's favicon for a site. Looked up by URL rather than bare domain: the
 * service has no icon for some bare domains (worldcc.com) whose site redirects
 * elsewhere (www.worldcc.com), and by URL it follows the redirect.
 */
export const siteFaviconUrl = (domain: string): string =>
  domain
    ? `https://www.google.com/s2/favicons?domain_url=${encodeURIComponent(`https://${domain}`)}&sz=16`
    : "";

/** Whether a link is one of Google's grounding redirects (a Gemini web source). */
export const isGroundingRedirect = (url: string | undefined): boolean =>
  !!url && hostOf(url) === GROUNDING_REDIRECT_HOST;
